import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=6879716a&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=6879716a&prod&lang=css"
import style1 from "./Tabs.vue?vue&type=style&index=1&id=6879716a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6879716a",
  null
  
)

export default component.exports